import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "ztn-drawer__header" }
const _hoisted_2 = { class: "ztn-page-h600-strong title" }
const _hoisted_3 = { class: "ztn-drawer__body" }
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ztn_button = _resolveComponent("ztn-button")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.modelValue)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "ztn-drawer-overlay",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "slide" }, {
      default: _withCtx(() => [
        (_ctx.modelValue)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["ztn-drawer", _ctx.CheckUtil.isMobile() ? 'ztn-drawer--full' : 'ztn-drawer--partial'])
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _renderSlot(_ctx.$slots, "header", {}, () => [
                    _createTextVNode(_toDisplayString(_ctx.title), 1)
                  ], true)
                ]),
                _createElementVNode("button", {
                  class: "ztn-drawer__close",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
                }, "✕")
              ]),
              _cache[2] || (_cache[2] = _createElementVNode("hr", null, null, -1)),
              _createElementVNode("div", _hoisted_3, [
                (!_ctx.hideEdit)
                  ? (_openBlock(), _createBlock(_component_ztn_button, {
                      key: 0,
                      onClick: _ctx.edit
                    }, {
                      default: _withCtx(() => [
                        _renderSlot(_ctx.$slots, "button", {}, () => [
                          _createTextVNode(_toDisplayString(_ctx.viewEditText), 1)
                        ], true)
                      ]),
                      _: 3
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (!_ctx.hideEdit)
                  ? (_openBlock(), _createElementBlock("hr", _hoisted_4))
                  : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "default", {}, undefined, true)
              ])
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}